import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=99e0cbea&scoped=true&"
import script from "./FaqSection.vue?vue&type=script&lang=js&"
export * from "./FaqSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e0cbea",
  null
  
)

export default component.exports